import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, IconButton, TextField, Chip, Stack, Tooltip, Divider, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, OutlinedInput } from '@mui/material';
import { Close } from '@mui/icons-material';
import navbar_background from '../assets/navbar_background.svg';
import { DataGrid, GridRenderCellParams, GridSortModel } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';

import endpoints from '../constants/endpoints';
import useFetch from '../hooks/useFetch';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { FilterKey, GlobalStateContext } from '../wrappers/GlobalContext';
import HelpIcon from '@mui/icons-material/Help';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import useApiRequest from '../services/apiRequest';
import InfoIcon from '@mui/icons-material/Info';
import React from 'react';


type Props = {
    open: boolean,
    user?: string,
    onClose: (() => void)
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function LogsDialog({ open, user, onClose }: Props) {

    const { queryStringConverter } = useApiRequest();

    const { translateFilter } = useContext(GlobalStateContext);
    const { userPermissions } = useContext(GlobalStateContext);
    const [pageSizeFacet, setPageSizeFacet] = useState<number>(10);
    const [currentPageFacet, setCurrentPageFacet] = useState<number>(0);
    const [openFilterDialog, setOpenFilterDialog] = useState(false);
    const [users, setUsers] = useState<string>(user ? user : '');
    const [actions, setActions] = useState<string[]>([]);
    const [queries, setQueries] = useState<string>('');
    const [inicialDate, setInicialDate] = useState<string>('');
    const [finalDate, setFinalDate] = useState<string>('');

    const [typedUsers, setTypedUsers] = useState<string>(users);
    const [typedActions, setTypedActions] = useState<string[]>([]);
    const [typedQueries, setTypedQueries] = useState<string>(queries);
    const [typedInicialDate, setTypedInicialDate] = useState<string>(inicialDate);
    const [typedFinalDate, setTypedFinalDate] = useState<string>(finalDate);

    const [openInfo, setOpenInfo] = useState(false);
    const [infoParams, setInfoParams] = useState<any>({});

    const [sortField, setSortField] = useState('data');
    const [sortOrder, setSortOrder] = useState('desc');

    const getUsers = () => {
        if (users === '') {
            return [];
        }
        const usersSplit = users.split(';').map(user => user.trim());
        return usersSplit;
    };

    const getQueries = () => {
        if (queries === '') {
            return [];
        }
        const queriesSplit = queries.split(';').map(query => query.trim());
        return queriesSplit;
    };

    const handleChange = (event: SelectChangeEvent<any>) => {
        const {
            target: { value },
        } = event;
        setTypedActions(
            typeof value === 'string' ? value.split(',') : value,
        );
    };




    const { data, loading } = useFetch(`${endpoints.GET_LOG}${queryStringConverter({ users: getUsers(), actions: actions, queries: getQueries(), initial_date: inicialDate, final_date: finalDate, page: currentPageFacet, size: pageSizeFacet, logged_user: userPermissions.usuario, sort: sortField, order: sortOrder, })}`)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const openMenu = Boolean(anchorEl);

    const handleApplyFilter = () => {
        setActions(typedActions);
        setQueries(typedQueries);
        setUsers(typedUsers);
        setInicialDate(typedInicialDate);
        setFinalDate(typedFinalDate);
    }

    const handleCloseFilter = () => {
        setOpenFilterDialog(false);
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseDialog = () => {
        setUsers('');
        setActions([]);
        setQueries('');
        setInicialDate('');
        setFinalDate('');
        onClose();
    }

    const handleSortModelChange = React.useCallback((sortModel: GridSortModel) => {
        setSortField(sortModel[0].field);
        setSortOrder(sortModel[0].sort || '');
    }, []);

    useEffect(() => {
        if (open) {
            if (userPermissions.type === 'user') {
                setUsers(userPermissions.usuario)
                setTypedUsers(userPermissions.usuario)
            } else {
                setUsers(user ? user : '');
                setTypedUsers(user ? user : '');
            }
            setActions([]);
            setTypedActions([])
            setQueries('');
            setTypedQueries('');
            setInicialDate('');
            setTypedInicialDate('');
            setFinalDate('');
            setTypedFinalDate('');
        }
    }, [open, user]);


    const cleanFilters = () => {
        if (userPermissions.type === 'user') {
            setUsers(userPermissions.usuario);
            setTypedUsers(userPermissions.usuario);

        } else {
            setUsers('');
            setTypedUsers('');
        }
        setActions([]);
        setTypedActions([]);
        setQueries('');
        setTypedQueries('');
        setInicialDate('');
        setTypedInicialDate('');
        setFinalDate('');
        setTypedFinalDate('');
    }

    const convertDateFormat = (dateString: string) => {
        if (!dateString) return '';

        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    };

    const renderCellInfo = (params: GridRenderCellParams) => {
        return (
            <IconButton color="primary" aria-label="add to shopping cart" onClick={() => {
                setInfoParams(params.row);
                setOpenInfo(true);
            }}>
                <InfoIcon />
            </IconButton>
        )
    }



    const renderParameters = (params: any) => {
        const parameters = params.row.parametros || {};
        let count = 0;
        const compactView = Object.entries(parameters)
            .map(([key, value], index) => {

                if (value != '' && value != null && count < 3) {
                    count++;
                    return (
                        <Typography key={index} variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {translateFilter(key as FilterKey)}: {String(value)}
                        </Typography>
                    )
                }

            });



        return (

            <Box sx={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {compactView}
            </Box>
        );
    }






    return (
        <>

            <Dialog open={openInfo} onClose={() => setOpenInfo(false)} aria-describedby="alert-dialog-slide-description" maxWidth='sm' fullWidth>
                <DialogTitle color='white' sx={{ bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                    <div className="flex flex-row">
                        <div className="basis-10/12">
                            <Typography variant="h4" color="white">
                                {infoParams.usuario} - {infoParams.consulta}
                            </Typography>
                        </div>
                        <div className="basis-1/12">
                            <IconButton
                                aria-label="close"
                                onClick={() => setOpenInfo(false)}
                                sx={{
                                    position: 'absolute',
                                    right: 15,
                                    top: 15,
                                }}
                            >
                                <Close sx={{ color: "white" }} />
                            </IconButton>
                        </div>

                    </div>


                </DialogTitle>
                <DialogContent className="dialog-content">
                    <p className='mt-2'><strong>Usuário:</strong> {infoParams.usuario}</p>
                    <p className='mt-2'><strong>Consulta:</strong> {infoParams.consulta}</p>
                    <p className='mt-2'><strong>Data:</strong> {infoParams.data}</p>
                    <p className='mt-2'><strong>Ação:</strong> {infoParams.acao}</p>

                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h4" textAlign='center' color="initial" sx={{ mb: 2 }}>Parâmetros</Typography>

                    {Object.entries(infoParams.parametros || []).map(([key, value], index) => {
                        if (value != '' && value != null) {
                            return (
                                <p className='mt-2'><strong>{translateFilter(key as FilterKey)}: </strong> {String(value)}</p>
                            )
                        }

                    })}

                </DialogContent>
            </Dialog>

            <Dialog
                open={open}
                keepMounted
                onClose={onClose}
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth='md'
            >
                <DialogTitle color='white' sx={{ bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                    <Typography variant='h4'>Logs</Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 15,
                            top: 15,
                        }}
                    >
                        <Close sx={{ color: "white" }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{}}>
                    <Box sx={{ height: 500, width: '100%' }}>
                        {data?.length === 0 ? <Typography variant='h6' textAlign={'center'} sx={{ mt: 5 }}>Nenhum log encontrado</Typography> :

                            <>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Box sx={{ display: 'flex' }}>

                                        {users !== '' && userPermissions.type !== 'user' ?
                                            <Stack direction="row" sx={{ ml: 1, width: '100%', justifyContent: 'space-between' }}>
                                                <Box sx={{ maxWidth: '90%' }}>
                                                    <Tooltip title={users}>
                                                        <Chip style={{ maxWidth: 250, marginLeft: 10 }} label={`Usuários: ${users}`} color="secondary" variant="outlined" size="small" />
                                                    </Tooltip>
                                                </Box>
                                            </Stack>
                                            : <></>
                                        }

                                        {actions.length > 0 &&
                                            <Stack direction="row" sx={{ ml: 1, width: '100%', justifyContent: 'space-between' }}>
                                                <Box sx={{ maxWidth: '90%' }}>
                                                    <Tooltip title={actions}>
                                                        <Chip style={{ maxWidth: 250, marginLeft: 10 }} label={`Ações: ${actions}`} color="secondary" variant="outlined" size="small" />
                                                    </Tooltip>
                                                </Box>
                                            </Stack>
                                        }

                                        {queries !== '' &&
                                            <Stack direction="row" sx={{ ml: 1, width: '100%', justifyContent: 'space-between' }}>
                                                <Box sx={{ maxWidth: '90%' }}>
                                                    <Tooltip title={queries}>
                                                        <Chip style={{ maxWidth: 250, marginLeft: 10 }} label={`Consultas: ${queries}`} color="secondary" variant="outlined" size="small" />
                                                    </Tooltip>
                                                </Box>
                                            </Stack>

                                        }

                                        {inicialDate !== '' &&
                                            <Stack direction="row" sx={{ ml: 1, width: '100%', justifyContent: 'space-between' }}>
                                                <Box sx={{ maxWidth: '90%' }}>
                                                    <Tooltip title={`de ${inicialDate} até ${finalDate}`}>
                                                        <Chip style={{ maxWidth: 250, marginLeft: 10 }} label={`Data inical: ${convertDateFormat(inicialDate)}`} color="secondary" variant="outlined" size="small" />
                                                    </Tooltip>
                                                </Box>
                                            </Stack>
                                        }

                                        {finalDate !== '' &&
                                            <Stack direction="row" sx={{ ml: 1, width: '100%', justifyContent: 'space-between' }}>
                                                <Box sx={{ maxWidth: '90%' }}>
                                                    <Tooltip title={`de ${inicialDate} até ${finalDate}`}>
                                                        <Chip style={{ maxWidth: 250, marginLeft: 10 }} label={`Data final: ${convertDateFormat(finalDate)}`} color="secondary" variant="outlined" size="small" />
                                                    </Tooltip>
                                                </Box>
                                            </Stack>
                                        }

                                        {userPermissions.type == 'user' && (actions.length > 0 || queries !== '' || inicialDate !== '' || finalDate !== '') ?
                                            <Button sx={{ ml: 4 }} variant='text' color="warning" size='small' startIcon={<HighlightOffIcon />} onClick={cleanFilters}>
                                                Resetar
                                            </Button>
                                            : <></>
                                        }

                                        {userPermissions.type !== 'user' && (users !== '' || actions.length > 0 || queries !== '' || inicialDate !== '' || finalDate !== '') ?
                                            <Button sx={{ ml: 4 }} variant='text' color="warning" size='small' startIcon={<HighlightOffIcon />} onClick={cleanFilters}>
                                                Resetar
                                            </Button>
                                            : <></>
                                        }

                                    </Box>

                                    <Button onClick={() => setOpenFilterDialog(true)} size='medium' ><FilterAltIcon /> Filtro</Button>
                                </Box>
                                <DataGrid
                                    hideFooterSelectedRowCount
                                    paginationMode='server'
                                    pageSize={pageSizeFacet}
                                    rows={data?.results || []}
                                    rowCount={data?.total || 0}
                                    page={currentPageFacet}
                                    onPageSizeChange={(newPageSize) => setPageSizeFacet(newPageSize)}
                                    onPageChange={(newPage) => setCurrentPageFacet(newPage)}
                                    columns={[
                                        { field: 'usuario', headerName: 'Usuário', width: 150 },
                                        { field: 'consulta', headerName: 'Consulta', width: 200 },
                                        { field: 'data', headerName: 'Data', width: 200 },
                                        { field: 'acao', headerName: 'Ação', width: 150 },
                                        { field: 'parametros', headerName: 'Prarâmetros', width: 150, sortable: false, renderCell: (params: any) => renderParameters(params) },
                                        { field: 'info', headerName: 'Info', width: 20, sortable: false, renderCell: (params: any) => renderCellInfo(params) },

                                    ]}
                                    sx={{ fontSize: 13, height: '95%' }}
                                    loading={loading}
                                    rowsPerPageOptions={[10, 25, 50]}
                                    onSortModelChange={handleSortModelChange}
                                />
                            </>

                        }

                    </Box>
                </DialogContent>
            </Dialog>

            <Dialog
                open={openFilterDialog}
                keepMounted
                onClose={() => handleCloseFilter()}
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth='sm'
            >
                <DialogTitle color='white' sx={{ bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                    <Typography variant='h4'>Filtros</Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleCloseFilter()}
                        sx={{
                            position: 'absolute',
                            right: 15,
                            top: 15,
                        }}
                    >
                        <Close sx={{ color: "white" }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ m: 2, }}>
                    <Tooltip title="teste">
                        <Tooltip title={<Typography variant="body1" color="white">Para pesquisar por múltiplos atributos, utilize ';' como separador.</Typography>} sx={{ float: 'right' }}>
                            <IconButton>
                                <HelpIcon />
                            </IconButton>
                        </Tooltip>
                    </Tooltip>
                    {userPermissions.type === 'admin' || userPermissions.type === 'super admin' ?
                        <TextField value={typedUsers} onChange={(ev) => { setTypedUsers(ev.target.value) }} id="outlined-basic" label="Usuários" variant="outlined" fullWidth sx={{ mb: 1, mt: 2 }} />
                        :
                        <></>
                    }


                    <FormControl sx={{ mb: 1}} fullWidth>
                        <InputLabel id="demo-multiple-name-label">Ações</InputLabel>
                        <Select
                            labelId="demo-multiple-name-label"
                            id="demo-multiple-name"
                            multiple
                            value={typedActions}
                            onChange={handleChange}
                            input={<OutlinedInput label="Ações" />}
                            MenuProps={MenuProps}
                        >
                            <MenuItem value={"Calcular sobrepreço"}>Calcular sobrepreço</MenuItem>
                            <MenuItem value={"Gerar arquivo"}>Gerar arquivo </MenuItem>
                            <MenuItem value={"Download do arquivo"}>Download do arquivo</MenuItem>
                            <MenuItem value={"Excluir arquivo"}>Excluir arquivo</MenuItem>
                            <MenuItem value={"Buscar itens"}>Buscar itens</MenuItem>
                            <MenuItem value={"Criar / editar usuário"}>Criar / editar usuário</MenuItem>
                            <MenuItem value={"Deletar usuário"}>Deletar usuário</MenuItem>
                            <MenuItem value={"Buscar sobrepreço pré calculado"}>Buscar sobrepreço pré calculado</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField value={typedQueries} onChange={(ev) => { setTypedQueries(ev.target.value) }} id="outlined-basic" label="Consultas" variant="outlined" fullWidth sx={{ mb: 1 }} />

                    <Box sx={{ border: 1, borderColor: '#d6d6d6', p: 1, px: 2 }}>
                        <Typography variant="body1" color='#727272'>Período</Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, mt: 1 }}>
                            <TextField value={typedInicialDate} onChange={(ev) => { setTypedInicialDate(ev.target.value) }} id="outlined-basic" label="De" variant="outlined" fullWidth sx={{ mb: 1 }} type='date' InputLabelProps={{ shrink: true }} />
                            <TextField value={typedFinalDate} onChange={(ev) => { setTypedFinalDate(ev.target.value) }} id="outlined-basic" label="Até" variant="outlined" fullWidth sx={{ mb: 1 }} type='date' InputLabelProps={{ shrink: true }} />
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => { handleApplyFilter(); handleCloseFilter() }} variant='contained'>Aplicar</Button>
                </DialogActions>
            </Dialog>

        </>

    );
}
export default LogsDialog;
